
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("c6u22", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");




const $e77954c2fac8bb43$var$RecursiveExcerptContext = /*#__PURE__*/ (0, $42omo.createContext)({
    hasKey: ()=>false,
    addKey: ()=>{},
    removeKey: ()=>{},
    isProviderAvailable: false
});
const $e77954c2fac8bb43$export$8fbc0efd03a015e = ({ children: children, excerptKey: excerptKey })=>{
    const keys = (0, $42omo.useMemo)(()=>{
        return new Set();
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (excerptKey) keys.add(excerptKey);
    }, [
        keys,
        excerptKey
    ]);
    const hasKey = (0, $42omo.useCallback)((key)=>{
        return keys.has(key);
    }, [
        keys
    ]);
    const addKey = (0, $42omo.useCallback)((key_0)=>{
        keys.add(key_0);
    }, [
        keys
    ]);
    const removeKey = (0, $42omo.useCallback)((key_1)=>{
        keys.delete(key_1);
    }, [
        keys
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>{
        return {
            hasKey: hasKey,
            addKey: addKey,
            removeKey: removeKey,
            isProviderAvailable: true
        };
    }, [
        hasKey,
        addKey,
        removeKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e77954c2fac8bb43$var$RecursiveExcerptContext.Provider, {
        value: contextValue
    }, children);
};
const $e77954c2fac8bb43$export$3f68eeb1746e8c90 = ()=>{
    return (0, $42omo.useContext)($e77954c2fac8bb43$var$RecursiveExcerptContext);
};









var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $iXCQx = parcelRequire("iXCQx");


var $aoVih = parcelRequire("aoVih");

const $0f05f8ec17df934b$var$i18n = (0, $cgtv4.defineMessages)({
    errorDescription: {
        id: "excerpt-include.recursive-error.description",
        defaultMessage: "This insert excerpt macro cannot insert an excerpt that it is nested within."
    }
});
const $0f05f8ec17df934b$export$6990faa355fa7d3 = ()=>{
    const $ = (0, $frIzR.c)(4);
    const intl = (0, $8C5kA.default)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($0f05f8ec17df934b$var$i18n.errorDescription);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "p"
        }, t0));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};









var $422HI = parcelRequire("422HI");


var $5kjCz = parcelRequire("5kjCz");


var $hUS75 = parcelRequire("hUS75");


var $e4o8D = parcelRequire("e4o8D");








var $gMc0m = parcelRequire("gMc0m");





var $1Zr9M = parcelRequire("1Zr9M");


var $kksmx = parcelRequire("kksmx");


var $5LTS4 = parcelRequire("5LTS4");





var $bX5uj = parcelRequire("bX5uj");


var $6mKj3 = parcelRequire("6mKj3");


var $dhEYL = parcelRequire("dhEYL");




const $586bbeb50503c018$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    emptyMacro: {
        id: "excerpt-include.empty",
        defaultMessage: "No excerpts found."
    },
    emptyMacroEdit: {
        id: "excerpt-include.empty.edit",
        defaultMessage: "Select{editIcon}to choose a different source page."
    },
    untitledExcerpt: {
        id: "excerpt-include.untitled",
        defaultMessage: "Untitled excerpt"
    }
});


const $5942172932878591$var$styles = {
    excerptInclude: "_1ul9idpf",
    inlineExcerptInclude: "_19pkv77o",
    emptyContent: "_1yt41b66 _1e0c1txw _4cvr1h6o _syazazsu"
};
const $5942172932878591$export$1980ed6e948b49ee = (t0)=>{
    const $ = (0, $frIzR.c)(51);
    const { adf: adf, contentId: contentId, pageId: pageId, shouldPanelBeDisplayed: shouldPanelBeDisplayed, excerptName: excerptName, targetContentTitle: targetContentTitle, mode: mode, extensionKey: extensionKey, macroNode: macroNode, macroId: macroId, RendererWrapper: RendererWrapper, isLegacyRenderer: isLegacyRenderer, mediaToken: mediaToken, isLivePage: isLivePage, renderServerPlaceholder: renderServerPlaceholder } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== macroNode) {
        t1 = (0, $5kjCz.getMacroAttributesFromADFNode)(macroNode);
        $[0] = macroNode;
        $[1] = t1;
    } else t1 = $[1];
    const attributes = t1;
    let t2;
    if ($[2] !== adf || $[3] !== excerptName) {
        t2 = ()=>{
            const emptyAdf = [
                {
                    type: "paragraph"
                }
            ];
            return !!adf && (!!excerptName || JSON.stringify(adf) !== JSON.stringify(emptyAdf));
        };
        $[2] = adf;
        $[3] = excerptName;
        $[4] = t2;
    } else t2 = $[4];
    const hasExcerpt = t2;
    let t3;
    if ($[5] !== RendererWrapper || $[6] !== adf || $[7] !== contentId || $[8] !== hasExcerpt || $[9] !== isLivePage || $[10] !== mediaToken || $[11] !== mode || $[12] !== shouldPanelBeDisplayed) {
        t3 = ()=>!hasExcerpt() ? /*#__PURE__*/ $42omo.createElement($5942172932878591$var$ExcerptIncludeEmpty, {
                mode: mode,
                shouldPanelBeDisplayed: shouldPanelBeDisplayed,
                isLivePage: isLivePage
            }) : /*#__PURE__*/ $42omo.createElement(RendererWrapper, {
                adf: adf,
                targetContentId: contentId,
                mediaToken: mediaToken,
                isInsideOfInlineExtension: !shouldPanelBeDisplayed
            });
        $[5] = RendererWrapper;
        $[6] = adf;
        $[7] = contentId;
        $[8] = hasExcerpt;
        $[9] = isLivePage;
        $[10] = mediaToken;
        $[11] = mode;
        $[12] = shouldPanelBeDisplayed;
        $[13] = t3;
    } else t3 = $[13];
    const getExcerptBody = t3;
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $gMc0m.default)([
            $5942172932878591$var$styles.excerptInclude,
            "ak-excerpt-include ak-renderer-extension"
        ]);
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== macroId || $[16] !== renderServerPlaceholder) {
        t5 = (0, $6mKj3.expVal)("confluence_frontend_fix_excerpt_include", "isEnabled", false) ? renderServerPlaceholder ? {
            "data-ssr-placeholder": macroId
        } : {
            "data-ssr-placeholder-replace": macroId
        } : {};
        $[15] = macroId;
        $[16] = renderServerPlaceholder;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== extensionKey || $[19] !== isLegacyRenderer || $[20] !== macroNode || $[21] !== pageId) {
        t6 = isLegacyRenderer && /*#__PURE__*/ $42omo.createElement((0, $5LTS4.ExtensionLoadingComplete), {
            contentId: pageId,
            extensionKey: extensionKey,
            node: macroNode
        });
        $[18] = extensionKey;
        $[19] = isLegacyRenderer;
        $[20] = macroNode;
        $[21] = pageId;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== excerptName || $[24] !== getExcerptBody || $[25] !== hasExcerpt || $[26] !== intl || $[27] !== shouldPanelBeDisplayed || $[28] !== targetContentTitle) {
        t7 = shouldPanelBeDisplayed ? /*#__PURE__*/ $42omo.createElement("span", {
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ $42omo.createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle, hasExcerpt() && /*#__PURE__*/ $42omo.createElement("span", {
            style: (0, $dhEYL.panelHeaderExcerpt)
        }, "| ", excerptName ?? intl.formatMessage((0, $586bbeb50503c018$export$a7357cdd1f0b0168).untitledExcerpt))), /*#__PURE__*/ $42omo.createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, getExcerptBody())) : getExcerptBody();
        $[23] = excerptName;
        $[24] = getExcerptBody;
        $[25] = hasExcerpt;
        $[26] = intl;
        $[27] = shouldPanelBeDisplayed;
        $[28] = targetContentTitle;
        $[29] = t7;
    } else t7 = $[29];
    let t8;
    if ($[30] !== macroId) {
        t8 = /*#__PURE__*/ $42omo.createElement((0, $kksmx.ExtensionSSRMark), {
            macroId: macroId,
            renderType: "ssr-new"
        });
        $[30] = macroId;
        $[31] = t8;
    } else t8 = $[31];
    let t9;
    if ($[32] !== macroNode || $[33] !== mode) {
        t9 = (0, $5kjCz.getExperienceName)(mode, macroNode);
        $[32] = macroNode;
        $[33] = mode;
        $[34] = t9;
    } else t9 = $[34];
    let t10;
    if ($[35] !== attributes || $[36] !== extensionKey || $[37] !== mode || $[38] !== pageId || $[39] !== t9) {
        t10 = /*#__PURE__*/ $42omo.createElement((0, $bX5uj.MacroExperienceSuccess), {
            contentId: pageId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            name: t9
        });
        $[35] = attributes;
        $[36] = extensionKey;
        $[37] = mode;
        $[38] = pageId;
        $[39] = t9;
        $[40] = t10;
    } else t10 = $[40];
    let t11;
    if ($[41] !== macroId || $[42] !== t10 || $[43] !== t5 || $[44] !== t6 || $[45] !== t7 || $[46] !== t8) {
        t11 = /*#__PURE__*/ $42omo.createElement("div", {
            "data-fabric-macro": macroId,
            className: t4,
            "data-testid": "excerpt-include-component",
            ...t5
        }, t6, t7, t8, t10);
        $[41] = macroId;
        $[42] = t10;
        $[43] = t5;
        $[44] = t6;
        $[45] = t7;
        $[46] = t8;
        $[47] = t11;
    } else t11 = $[47];
    const excerptIncludeComponent = t11;
    let t12;
    if ($[48] !== excerptIncludeComponent || $[49] !== shouldPanelBeDisplayed) {
        t12 = !shouldPanelBeDisplayed && (0, $6mKj3.expVal)("confluence_insert_excerpt_inline_vertical_align", "isEnabled", false) ? /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "inline-excerpt-include-component",
            className: (0, $gMc0m.default)([
                $5942172932878591$var$styles.inlineExcerptInclude
            ])
        }, excerptIncludeComponent) : excerptIncludeComponent;
        $[48] = excerptIncludeComponent;
        $[49] = shouldPanelBeDisplayed;
        $[50] = t12;
    } else t12 = $[50];
    return t12;
};
const $5942172932878591$var$ExcerptIncludeEmpty = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { mode: mode, shouldPanelBeDisplayed: shouldPanelBeDisplayed, isLivePage: isLivePage } = t0;
    const intl = (0, $8C5kA.default)();
    if (!shouldPanelBeDisplayed && !(mode === "editor" && !isLivePage)) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            $5942172932878591$var$styles.emptyContent
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== intl) {
        t2 = intl.formatMessage((0, $586bbeb50503c018$export$a7357cdd1f0b0168).emptyMacro);
        $[1] = intl;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== intl || $[4] !== isLivePage || $[5] !== mode) {
        t3 = mode === "editor" && !isLivePage && intl.formatMessage((0, $586bbeb50503c018$export$a7357cdd1f0b0168).emptyMacroEdit, {
            editIcon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                label: "edit",
                color: "var(--ds-icon, #292A2E)"
            })
        });
        $[3] = intl;
        $[4] = isLivePage;
        $[5] = mode;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t1
        }, t2, t3);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};



var $f9KPY = parcelRequire("f9KPY");





var $gmMgo = parcelRequire("gmMgo");


var $ebrpi = parcelRequire("ebrpi");

class $6d5b4820d47006ab$var$ExcerptIncludeErrorComponent extends (0, $42omo.PureComponent) {
    render() {
        const { targetContentTitle: targetContentTitle, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'inline-block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                borderRadius: 5,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: 668,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 25,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                padding: "var(--ds-space-050, 4px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                paddingLeft: "var(--ds-space-050, 4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                verticalAlign: 'text-bottom'
            }
        }, intl.formatMessage({
            id: "editor.excerpt.include.macro.error"
        }, {
            0: targetContentTitle
        })));
    }
}
const $6d5b4820d47006ab$export$9959a21ec1aff866 = (0, $gmMgo.default)($6d5b4820d47006ab$var$ExcerptIncludeErrorComponent);


const $6818d60359395137$export$9c17ec9416db96e4 = (macroOutput)=>{
    try {
        if (macroOutput) {
            const parsed = JSON.parse(macroOutput);
            if (parsed.version === 1 && parsed.type === 'doc' && parsed.content) return parsed;
        }
    } catch (e) {
    // do nothing in case of parsing error, which would return `undefined`
    }
};
const $6818d60359395137$export$47eae2202f029f6b = (node)=>node?.parameters?.macroMetadata?.macroId?.value;
const $6818d60359395137$export$a22f425ed063044b = (node, name)=>node?.parameters?.macroParams?.[name]?.value;






var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");


var $3en7c = parcelRequire("3en7c");

const $2d128bc66f1b6031$export$81bec6e38e8b706b = ({ cfetch: cfetch }, resource, init)=>cfetch(resource, {
        ...init,
        headers: {
            Accept: (0, $aBfpe.MediaType).JSON,
            ...init?.headers
        }
    }).then((response)=>response.json().catch((error)=>(0, $3en7c.throwErrorWithResponse)(error, response)));





const $742bec8a860b95f0$var$queryGraphQL = (network, { query: query, variables: variables })=>(0, $2d128bc66f1b6031$export$81bec6e38e8b706b)(network, '/cgraphql', {
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            variables: variables,
            query: query
        })
    });
/**
 * Recursively parses an ADF and returns all nodes that match a given extension
 * key.
 *
 * @param extensionKey The extension key to search for (e.g. 'excerpt-include')
 * @param currentNode The ADF node to recursively search through
 */ const $742bec8a860b95f0$var$parseForTargetMacroNodeByExtensionKey = (extensionKey, currentNode)=>currentNode?.attrs?.extensionKey === extensionKey ? [
        currentNode
    ] : currentNode.content ? currentNode.content.reduce((matchedSubNodes, childNode)=>matchedSubNodes.concat($742bec8a860b95f0$var$parseForTargetMacroNodeByExtensionKey(extensionKey, childNode)), []) : [];
/**
 * Queries cc-graphql for content with a given title, space, and type.
 *
 * @param cfetch cfetch
 * @param contentTitle The title of the content to query by (needs space key)
 * @param spaceKey The space key of the content
 * @param type Either "page" or "blogpost"
 */ const $742bec8a860b95f0$var$queryContent = (network, contentTitle, spaceKey, type)=>$742bec8a860b95f0$var$queryGraphQL(network, {
        query: `
      query excerptIncludeTargetPageQuery(
        $contentTitle: String!
        $spaceKey: String!
        $type: String!
      ) {
        content(title: $contentTitle, spaceKey: $spaceKey, type: $type) {
          nodes {
            id
            body {
              atlas_doc_format {
                value
              }
            }
          }
        }
      }
    `,
        variables: {
            contentTitle: contentTitle,
            spaceKey: spaceKey,
            type: type
        }
    });
const $742bec8a860b95f0$var$queryContentById = (network, contentId)=>$742bec8a860b95f0$var$queryGraphQL(network, {
        query: `
      query excerptIncludeTargetPageQueryById(
        $contentId: ID!
      ) {
        content(id: $contentId) {
          nodes {
            id
            body {
              atlas_doc_format {
                value
              }
            }
          }
        }
      }
    `,
        variables: {
            contentId: contentId
        }
    });
const $742bec8a860b95f0$var$getSpaceKey = (network, contentId)=>$742bec8a860b95f0$var$queryGraphQL(network, {
        query: `
      query consumerSpaceQuery($contentId: ID!) {
        content(id: $contentId, status: ["current", "draft"]) {
          nodes {
            id
            space {
              key
            }
          }
        }
      }
    `,
        variables: {
            contentId: contentId
        }
    });
/**
 * Guesses at whether the given title is from a blog or not (unreliable as
 * shiiiiiiiit).
 *
 * TODO: Remove dis.
 *
 * @param contentTitle The title of the content
 */ const $742bec8a860b95f0$var$isPossiblyBlogpost = (contentTitle)=>contentTitle.match(/^\/\d{4}\/\d{2}\/\d{2}\//) !== null;
/**
 * Guesses at whether the given title is from an external space or not.
 *
 * TODO: Remove this.
 *
 * @param contentInfo The title of the content
 */ const $742bec8a860b95f0$var$isPossiblyExternalContent = (contentInfo)=>contentInfo.indexOf(':') !== -1;
// Length of the date prefix that is in the data returned by the macro
const $742bec8a860b95f0$var$blogPrefixLength = 12;
/**
 * Removes the blog title prefix from the given content info.
 *
 * @param contentInfo The content info containing a blog title w/ prefix
 */ const $742bec8a860b95f0$var$getBlogpostTitle = (contentInfo)=>contentInfo.slice($742bec8a860b95f0$var$blogPrefixLength);
/**
 * For a content title that's prefixed with the space key, this strips the
 * space key out assuming that it matches the pattern `${SPACE_KEY}:${TITILE}`.
 *
 * @param contentInfo A content title assumedly prefixed with space key + ":"
 */ const $742bec8a860b95f0$var$getExternalContentTitle = (contentInfo)=>contentInfo.slice(contentInfo.indexOf(':') + 1);
/**
 * For a content title that's prefixed with the space key, this strips the
 * title out assuming that it matches the pattern `${SPACE_KEY}:${TITILE}`.
 *
 * @param contentInfo A content title assumedly prefixed with space key + ":"
 */ const $742bec8a860b95f0$var$getExternalSpaceKey = (contentInfo)=>contentInfo.slice(0, contentInfo.indexOf(':'));
const $742bec8a860b95f0$export$6a8851a6a483507b = (_, args, { network: network })=>{
    const { contentId: contentId, macroNode: { extensionKey: extensionKey, parameters: { macroParams: macroParamsString } } } = args;
    // Handles what logic to do based on the macro's extension key
    switch(extensionKey){
        case 'excerpt-include':
            const macroParams = JSON.parse(macroParamsString);
            const targetContentId = macroParams?._referencedContentId?.value ?? null;
            if (targetContentId !== null) return $742bec8a860b95f0$var$handleExcerptIncludeByTargetId(targetContentId, macroParams, network);
            else return $742bec8a860b95f0$var$handleExcerptInclude(contentId, macroParams, network);
        default:
            return Promise.resolve(null);
    }
};
const $742bec8a860b95f0$var$handleExcerptIncludeByTargetId = async (targetContentId, macroParams, network)=>{
    const response = await $742bec8a860b95f0$var$queryContentById(network, targetContentId);
    const targetPageAdfString = response?.data?.content?.nodes[0]?.body?.atlas_doc_format?.value ?? null;
    return $742bec8a860b95f0$var$formatResponse(targetPageAdfString, targetContentId, macroParams);
};
/**
 * Handles the payload logic for the excerpt include macro.
 *
 * This shotguns four queries, and then uses the response of whatever sticks
 * first. That response contains an ADF node that we parse to find the first
 * instance of an excerpt macro. We then return that macros content
 * stringified.
 *
 * @param contentId The excerpt include macro's content ID
 * @param macroParams The params object from the excerpt macro
 * @param cfetch cfetch
 */ const $742bec8a860b95f0$var$handleExcerptInclude = (contentId, macroParams, network)=>// We need to get the space key of the excerpt include macro so we can check
    // if the excerpt macro is from the same space.
    $742bec8a860b95f0$var$getSpaceKey(network, contentId).then((consumerContextResponse)=>{
        // This is either going to be of the pattern "${TITLE}",
        // "${SPACE_KEY}:${TITLE}", "/YYYY/MM/DD/${TITLE}",
        // "${SPACE_KEY}:/YYYY/MM/DD/${TITLE}". Unfortunately, we don't know
        // which we're getting, so we'll query them all.
        const targetPageInfo = macroParams?.['']?.value;
        const consumerSpaceKey = consumerContextResponse?.data?.content?.nodes?.[0]?.space?.key;
        // Just shotgun it, and grab one that sticks
        return Promise.all([
            // Page within current space "${TITLE}"
            $742bec8a860b95f0$var$queryContent(network, targetPageInfo, consumerSpaceKey, 'page'),
            // Blogpost within current space "/YYYY/MM/DD/${TITLE}"
            $742bec8a860b95f0$var$isPossiblyBlogpost(targetPageInfo) ? $742bec8a860b95f0$var$queryContent(network, $742bec8a860b95f0$var$getBlogpostTitle(targetPageInfo), consumerSpaceKey, 'blogpost') : Promise.resolve(null),
            // Page within outside space "${SPACE_KEY}:${TITLE}"
            $742bec8a860b95f0$var$isPossiblyExternalContent(targetPageInfo) ? $742bec8a860b95f0$var$queryContent(network, $742bec8a860b95f0$var$getExternalContentTitle(targetPageInfo), $742bec8a860b95f0$var$getExternalSpaceKey(targetPageInfo), 'page') : Promise.resolve(null),
            // Blogpost within outside space "${SPACE_KEY}:/YYYY/MM/DD/${TITLE}"
            $742bec8a860b95f0$var$isPossiblyExternalContent(targetPageInfo) && $742bec8a860b95f0$var$isPossiblyBlogpost($742bec8a860b95f0$var$getExternalContentTitle(targetPageInfo)) ? $742bec8a860b95f0$var$queryContent(network, $742bec8a860b95f0$var$getBlogpostTitle($742bec8a860b95f0$var$getExternalContentTitle(targetPageInfo)), $742bec8a860b95f0$var$getExternalSpaceKey(targetPageInfo), 'blogpost') : Promise.resolve(null)
        ]).then((responses)=>{
            // Go through the response and get the first valid adf string, and the associated contentId
            let targetPageAdfString = null;
            let targetContentId = null;
            responses.some((response)=>{
                targetPageAdfString = response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.value || null;
                if (targetPageAdfString) {
                    targetContentId = response?.data?.content?.nodes?.[0]?.id || null;
                    return true;
                }
            });
            return $742bec8a860b95f0$var$formatResponse(targetPageAdfString, targetContentId, macroParams);
        });
    });
const $742bec8a860b95f0$var$formatResponse = (targetPageAdfString, targetContentId, macroParams)=>{
    // If we didn't get anything, just return null
    if (!targetPageAdfString) return {
        payload: null,
        contentId: null
    };
    const targetAdf = JSON.parse(targetPageAdfString);
    // If a excerpt name is given, then we try to find the excerpt with name, otherwise we grab the first excerpt
    const excerptName = macroParams?.['name']?.value;
    const targetNodes = $742bec8a860b95f0$var$parseForTargetMacroNodeByExtensionKey('excerpt', targetAdf);
    let targetNodeContent = targetNodes[0]?.content;
    if (excerptName) targetNodeContent = targetNodes.find((node)=>node?.attrs?.parameters?.macroParams['name']?.value?.toUpperCase?.() === excerptName.toUpperCase())?.content;
    const payload = targetNodeContent ? JSON.stringify(targetNodeContent) : null;
    return {
        payload: payload,
        contentId: targetContentId
    };
};



var $f7B1p = parcelRequire("f7B1p");

const $49cc3e2647f46bd6$export$f10f4b8a29d2407e = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { variables: variables, skip: t1, fetchPolicy: t2 } = t0;
    const skip = t1 === undefined ? false : t1;
    const fetchPolicy = t2 === undefined ? "cache-first" : t2;
    let t3;
    if ($[0] !== variables) {
        t3 = async ()=>{
            const result = await (0, $742bec8a860b95f0$export$6a8851a6a483507b)({}, variables, {
                network: {
                    cfetch: $f7B1p.cfetch
                }
            });
            return {
                experimentalMacroMetadata: result ? {
                    payload: result.payload ?? null,
                    contentId: result.contentId ?? null
                } : null
            };
        };
        $[0] = variables;
        $[1] = t3;
    } else t3 = $[1];
    const fetchData = t3;
    let t4;
    if ($[2] !== variables) {
        t4 = JSON.stringify({
            query: "experimentalMacroMetadata",
            variables: variables
        });
        $[2] = variables;
        $[3] = t4;
    } else t4 = $[3];
    const key = t4;
    let t5;
    if ($[4] !== fetchData || $[5] !== fetchPolicy || $[6] !== key || $[7] !== skip || $[8] !== variables) {
        t5 = {
            key: key,
            fetchData: fetchData,
            variables: variables,
            skip: skip,
            fetchPolicy: fetchPolicy
        };
        $[4] = fetchData;
        $[5] = fetchPolicy;
        $[6] = key;
        $[7] = skip;
        $[8] = variables;
        $[9] = t5;
    } else t5 = $[9];
    return (0, $dK51B.useExperimentalQueryBase)(t5);
};


const $a28c11b9954ec4f2$export$358a2d09bf0dde5a = (t0)=>{
    const $ = (0, $frIzR.c)(80);
    const { contentId: contentId, spaceKey: spaceKey, extensionKey: extensionKey, macroNode: macroNode, mode: mode, RendererWrapper: RendererWrapper, isLegacyRenderer: isLegacyRenderer, isLivePage: isLivePage } = t0;
    const { extensionType: extensionType, parameters: t1, type: type } = macroNode;
    const { macroMetadata: macroMetadata, macroParams: macroParams, macroOutput: macroOutput, mediaToken: mediaToken } = t1;
    let t2;
    if ($[0] !== macroNode) {
        t2 = (0, $5kjCz.getMacroAttributesFromADFNode)(macroNode);
        $[0] = macroNode;
        $[1] = t2;
    } else t2 = $[1];
    const attributes = t2;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const adfFromMacroOutput = (0, $6818d60359395137$export$9c17ec9416db96e4)(macroOutput)?.content;
    const t3 = extensionKey ?? "";
    let t4;
    if ($[2] !== macroMetadata) {
        t4 = JSON.stringify(macroMetadata);
        $[2] = macroMetadata;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== macroParams) {
        t5 = JSON.stringify(macroParams);
        $[4] = macroParams;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t4 || $[7] !== t5) {
        t6 = {
            macroMetadata: t4,
            macroParams: t5
        };
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    const t7 = type ?? "";
    let t8;
    if ($[9] !== extensionType || $[10] !== t3 || $[11] !== t6 || $[12] !== t7) {
        t8 = {
            extensionKey: t3,
            extensionType: extensionType,
            parameters: t6,
            type: t7
        };
        $[9] = extensionType;
        $[10] = t3;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== contentId || $[15] !== t8) {
        t9 = {
            contentId: contentId,
            macroNode: t8
        };
        $[14] = contentId;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    const t10 = !!adfFromMacroOutput;
    let t11;
    if ($[17] !== t10 || $[18] !== t9) {
        t11 = {
            variables: t9,
            skip: t10
        };
        $[17] = t10;
        $[18] = t9;
        $[19] = t11;
    } else t11 = $[19];
    const { data: data, loading: loading, error: error } = (0, $49cc3e2647f46bd6$export$f10f4b8a29d2407e)(t11);
    let t12;
    if ($[20] !== macroNode) {
        t12 = (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "") || "";
        $[20] = macroNode;
        $[21] = t12;
    } else t12 = $[21];
    const targetContentTitle = t12;
    let t13;
    if ($[22] !== macroNode) {
        t13 = (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "nopanel");
        $[22] = macroNode;
        $[23] = t13;
    } else t13 = $[23];
    const shouldPanelBeDisplayed = t13 !== "true";
    let t14;
    if ($[24] !== macroNode) {
        t14 = (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "inline");
        $[24] = macroNode;
        $[25] = t14;
    } else t14 = $[25];
    const displayInline = t14 === "true";
    let t15;
    if ($[26] !== macroNode) {
        t15 = (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "name");
        $[26] = macroNode;
        $[27] = t15;
    } else t15 = $[27];
    const excerptName = t15;
    let t16;
    if ($[28] !== macroNode) {
        t16 = (0, $6818d60359395137$export$47eae2202f029f6b)(macroNode);
        $[28] = macroNode;
        $[29] = t16;
    } else t16 = $[29];
    const macroId = t16;
    let t17;
    if ($[30] !== contentId || $[31] !== data?.experimentalMacroMetadata?.contentId || $[32] !== macroNode) {
        t17 = data?.experimentalMacroMetadata?.contentId || (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "_parentId") || contentId || "";
        $[30] = contentId;
        $[31] = data?.experimentalMacroMetadata?.contentId;
        $[32] = macroNode;
        $[33] = t17;
    } else t17 = $[33];
    const targetContentId = t17;
    let t18;
    if ($[34] !== RendererWrapper || $[35] !== contentId || $[36] !== displayInline || $[37] !== excerptName || $[38] !== extensionKey || $[39] !== isLegacyRenderer || $[40] !== isLivePage || $[41] !== macroId || $[42] !== macroNode || $[43] !== mode || $[44] !== shouldPanelBeDisplayed || $[45] !== spaceKey || $[46] !== targetContentTitle) {
        t18 = {
            RendererWrapper: RendererWrapper,
            extensionKey: extensionKey,
            macroNode: macroNode,
            mode: mode,
            pageId: contentId,
            spaceKey: spaceKey,
            shouldPanelBeDisplayed: shouldPanelBeDisplayed,
            displayInline: displayInline,
            excerptName: excerptName,
            targetContentTitle: targetContentTitle,
            macroId: macroId,
            isLegacyRenderer: isLegacyRenderer,
            isLivePage: isLivePage
        };
        $[34] = RendererWrapper;
        $[35] = contentId;
        $[36] = displayInline;
        $[37] = excerptName;
        $[38] = extensionKey;
        $[39] = isLegacyRenderer;
        $[40] = isLivePage;
        $[41] = macroId;
        $[42] = macroNode;
        $[43] = mode;
        $[44] = shouldPanelBeDisplayed;
        $[45] = spaceKey;
        $[46] = targetContentTitle;
        $[47] = t18;
    } else t18 = $[47];
    const props = t18;
    if (adfFromMacroOutput) {
        let t19;
        if ($[48] !== adfFromMacroOutput || $[49] !== mediaToken || $[50] !== props || $[51] !== renderServerPlaceholder || $[52] !== targetContentId) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5942172932878591$export$1980ed6e948b49ee), {
                ...props,
                adf: adfFromMacroOutput,
                contentId: targetContentId,
                mediaToken: mediaToken,
                renderServerPlaceholder: renderServerPlaceholder
            });
            $[48] = adfFromMacroOutput;
            $[49] = mediaToken;
            $[50] = props;
            $[51] = renderServerPlaceholder;
            $[52] = targetContentId;
            $[53] = t19;
        } else t19 = $[53];
        return t19;
    }
    if (loading) {
        let t19;
        if ($[54] !== shouldPanelBeDisplayed || $[55] !== targetContentTitle) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f9KPY.ExcerptIncludeComponentShadow), {
                shouldPanelBeDisplayed: shouldPanelBeDisplayed,
                targetContentTitle: targetContentTitle
            });
            $[54] = shouldPanelBeDisplayed;
            $[55] = targetContentTitle;
            $[56] = t19;
        } else t19 = $[56];
        return t19;
    }
    const adfString = data?.experimentalMacroMetadata?.payload;
    if (error) {
        let t19;
        if ($[57] !== error || $[58] !== extensionKey) {
            t19 = error || new (0, $422HI.ApolloErrorInterop)({
                errorMessage: `${extensionKey} failed to render because macro metadata payload is empty`
            });
            $[57] = error;
            $[58] = extensionKey;
            $[59] = t19;
        } else t19 = $[59];
        const queryError = t19;
        let t20;
        if ($[60] !== macroNode || $[61] !== mode) {
            t20 = (0, $5kjCz.getExperienceName)(mode, macroNode);
            $[60] = macroNode;
            $[61] = mode;
            $[62] = t20;
        } else t20 = $[62];
        let t21;
        if ($[63] !== attributes || $[64] !== contentId || $[65] !== mode || $[66] !== queryError || $[67] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hUS75.MacroExperienceStop), {
                error: queryError,
                mode: mode,
                name: t20,
                attributes: attributes,
                contentId: contentId,
                source: "ExcerptIncludeImpl"
            });
            $[63] = attributes;
            $[64] = contentId;
            $[65] = mode;
            $[66] = queryError;
            $[67] = t20;
            $[68] = t21;
        } else t21 = $[68];
        let t22;
        if ($[69] !== targetContentTitle) {
            t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6d5b4820d47006ab$export$9959a21ec1aff866), {
                targetContentTitle: targetContentTitle
            });
            $[69] = targetContentTitle;
            $[70] = t22;
        } else t22 = $[70];
        let t23;
        if ($[71] !== t21 || $[72] !== t22) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t21, t22);
            $[71] = t21;
            $[72] = t22;
            $[73] = t23;
        } else t23 = $[73];
        return t23;
    }
    let t19;
    if ($[74] !== adfString) {
        t19 = adfString ? JSON.parse(adfString) : undefined;
        $[74] = adfString;
        $[75] = t19;
    } else t19 = $[75];
    let t20;
    if ($[76] !== props || $[77] !== t19 || $[78] !== targetContentId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5942172932878591$export$1980ed6e948b49ee), {
            ...props,
            adf: t19,
            contentId: targetContentId
        });
        $[76] = props;
        $[77] = t19;
        $[78] = targetContentId;
        $[79] = t20;
    } else t20 = $[79];
    return t20;
};


const $c6f28e626bacffe3$export$f31130fd0c7ad090 = (props)=>{
    const $ = (0, $frIzR.c)(15);
    const { isProviderAvailable: isProviderAvailable, addKey: addKey, hasKey: hasKey, removeKey: removeKey } = (0, $e77954c2fac8bb43$export$3f68eeb1746e8c90)();
    const [circularReferenceDetected, setCircularReferenceDetected] = (0, $42omo.useState)(undefined);
    const excerptPageTitle = props?.macroNode?.parameters?.macroParams?.[""]?.value;
    const excerptName = props?.macroNode?.parameters?.macroParams?.name?.value ?? "UNDEFINED_EXCERPT_NAME";
    const excerptKeyFromMacroParams = excerptPageTitle !== undefined ? `${excerptPageTitle}-${excerptName}` : undefined;
    let t0;
    let t1;
    if ($[0] !== addKey || $[1] !== excerptKeyFromMacroParams || $[2] !== hasKey || $[3] !== isProviderAvailable || $[4] !== removeKey) {
        t0 = ()=>{
            if (!excerptKeyFromMacroParams || !isProviderAvailable) return;
            let didAdd = false;
            if (hasKey(excerptKeyFromMacroParams)) setCircularReferenceDetected(true);
            else {
                setCircularReferenceDetected(false);
                addKey(excerptKeyFromMacroParams);
                didAdd = true;
            }
            return ()=>{
                if (didAdd) removeKey(excerptKeyFromMacroParams);
            };
        };
        t1 = [
            excerptKeyFromMacroParams,
            isProviderAvailable,
            hasKey,
            addKey,
            removeKey
        ];
        $[0] = addKey;
        $[1] = excerptKeyFromMacroParams;
        $[2] = hasKey;
        $[3] = isProviderAvailable;
        $[4] = removeKey;
        $[5] = t0;
        $[6] = t1;
    } else {
        t0 = $[5];
        t1 = $[6];
    }
    (0, $42omo.useEffect)(t0, t1);
    if (!isProviderAvailable) {
        let t2;
        if ($[7] !== props) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a28c11b9954ec4f2$export$358a2d09bf0dde5a), props);
            $[7] = props;
            $[8] = t2;
        } else t2 = $[8];
        let t3;
        if ($[9] !== excerptKeyFromMacroParams || $[10] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e77954c2fac8bb43$export$8fbc0efd03a015e), {
                excerptKey: excerptKeyFromMacroParams
            }, t2);
            $[9] = excerptKeyFromMacroParams;
            $[10] = t2;
            $[11] = t3;
        } else t3 = $[11];
        return t3;
    } else {
        if (circularReferenceDetected === undefined) return null;
        else if (circularReferenceDetected) {
            let t2;
            if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0f05f8ec17df934b$export$6990faa355fa7d3), null);
                $[12] = t2;
            } else t2 = $[12];
            return t2;
        } else {
            let t2;
            if ($[13] !== props) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a28c11b9954ec4f2$export$358a2d09bf0dde5a), props);
                $[13] = props;
                $[14] = t2;
            } else t2 = $[14];
            return t2;
        }
    }
};
module.exports["ExcerptInclude"] = $c6f28e626bacffe3$export$f31130fd0c7ad090;

});

parcelRegister("3en7c", function(module, exports) {

var $b4EKK = parcelRequire("b4EKK");

function $26ae9e969f6c4de1$export$8a24908f7aac7ac7(error, response) {
    throw (0, $b4EKK.getErrorWithResponse)(error, response);
}
module.exports["throwErrorWithResponse"] = $26ae9e969f6c4de1$export$8a24908f7aac7ac7;

});

parcelRegister("b4EKK", function(module, exports) {
function $9a7b0181c65e47f8$export$d882ca6820b0f4f3(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    return error;
}
module.exports["getErrorWithResponse"] = $9a7b0181c65e47f8$export$d882ca6820b0f4f3;

});


//# sourceMappingURL=ExcerptInclude.a5163b60.js.map
